var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorCircleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4622",
    "data-name": "Group 4622",
    transform: "translate(-906.644 -398)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-close-circle",
    "data-name": "Icon ionic-md-close-circle",
    d: "M14.375,3.375a11,11,0,1,0,11,11A10.962,10.962,0,0,0,14.375,3.375Zm5.5,14.96-1.54,1.54-3.96-3.96-3.96,3.96-1.54-1.54,3.96-3.96-3.96-3.96,1.54-1.54,3.96,3.96,3.96-3.96,1.54,1.54-3.96,3.96Z",
    transform: "translate(903.269 394.625)",
    fill: "#e99797"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCircleIcon);
export default __webpack_public_path__ + "static/media/errorCircleIcon.19885ad4846b8083ee32cb366af0afa7.svg";
export { ForwardRef as ReactComponent };